import Vue from 'vue';

import CookiesApp from './Cookies.vue';

const mount_point = document.createElement('div');

document.body.appendChild(mount_point);

const vm = new Vue({
    el: mount_point,
    render: h => h(CookiesApp, {
        props: {
            cookies_key: '__TECHNE__COOKIES__',
            message: `Bienvenue sur Technè ! Nous souhaitons utiliser des cookies pour nos statistiques et vous permettre de nous poser des questions via un chat.`,
            available_choices: {
                stats: {
                    label: 'Statistiques de visite',
                    ok_fn: () => {
                        const s = document.createElement('script');
                        s.src = `https://stats.documents.design/js/plausible.js`;
                        s.setAttribute('data-domain', 'techne-bookshop.fr');
                        document.head.appendChild(s);
                    },
                },
                chat: {
                    label: 'Chat',
                    ok_fn: () => {
                        const crisp_script = `window.$crisp = [];
                    window.CRISP_WEBSITE_ID = "024f527d-07a7-4880-9c84-39c69fcb3ef2";
                    (function() {
                        d = document;
                        s = d.createElement("script");
                        s.src = "https://client.crisp.chat/l.js";
                        s.async = 1;
                        d.getElementsByTagName("head")[0].appendChild(s);
                    })();`;
                        const s = document.createElement('script');
                        s.innerHTML = crisp_script;
                        document.head.appendChild(s);
                    },
                }
            }
        }
    })
});